__turbopack_context__.v({
  "className": "body_2875ffea-module__KlW4aa__className",
  "variable": "body_2875ffea-module__KlW4aa__variable",
});
